import { fetchSeo } from './adminBrands'

/**
 * Ответ /api/get/seo без записи в БД — пустой объект или без id.
 * @param {*} data
 */
export function isSeoRecord(data) {
  if (!data || typeof data !== 'object') {
    return false
  }
  const id = data.id
  return id !== undefined && id !== null && id !== '' && Number(id) > 0
}

/**
 * @param {string} path — путь страницы, например "/" или "/about"
 * @returns {Promise<object|null>}
 */
export async function fetchSeoByPath(path) {
  try {
    const data = await fetchSeo(path || '/')
    return isSeoRecord(data) ? data : null
  } catch (e) {
    console.warn('SEO: не удалось загрузить данные', e.message)
  }
  return null
}
